import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoImg from "../../assets/img/branding/logo.png";

export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper
            className="flexSpaceCenter"
            style={{
              padding: "30px 0 16px 0",
              alignItems: "flex-start",
            }}
          >
            <Link
              className="flexCenter animate pointer"
              to="home"
              smooth={true}
              offset={-80}
            >
              <img src={LogoImg} alt="" width={32} />
              <h1
                className="font15 extraBold whiteColor"
                style={{ marginTop: "10px", marginLeft: "15px", }}
              >
                Nami
              </h1>
            </Link>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
                alignItems: "center",
              }}
            >
              <a href="/terms" className="text-white" style={{ color: "white" }}>
                Terms & Conditions
              </a>
              <a href="/privacy" style={{ color: "white" }}>
                Privacy Policy
              </a>
              <a href="/help" style={{ color: "white" }}>
                Help
              </a>
            </div>
            <Link
              className="whiteColor animate pointer font13"
              to="home"
              smooth={true}
              offset={-80}
            >
              Back to top
            </Link>
          </InnerWrapper>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: 16,
            }}
          >
            <StyleP className="whiteColor font13">
              © {getCurrentYear()} -{" "}
              <span className="font13">
                <span>Fabriq Technologies Ltd.</span>
              </span>{" "}
              All Right Reserved
            </StyleP>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;
